export default [
  {
    id: '1',
    language: 'Português',
    tag: 'pt',
  },
  {
    id: '2',
    language: 'English',
    tag: 'en',
  },
  {
    id: '3',
    language: 'Español',
    tag: 'es',
  },
];
